import { render, staticRenderFns } from "./LeadTimeTable.vue?vue&type=template&id=2b0a9162&scoped=true"
import script from "./LeadTimeTable.vue?vue&type=script&lang=js"
export * from "./LeadTimeTable.vue?vue&type=script&lang=js"
import style0 from "./LeadTimeTable.vue?vue&type=style&index=0&id=2b0a9162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0a9162",
  null
  
)

export default component.exports